import "core-js/modules/es.reflect.construct.js";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _initializerDefineProperty from "@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/esm/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/esm/initializerWarningHelper";
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/esnext.set.add-all.js";
import "core-js/modules/esnext.set.delete-all.js";
import "core-js/modules/esnext.set.difference.js";
import "core-js/modules/esnext.set.every.js";
import "core-js/modules/esnext.set.filter.js";
import "core-js/modules/esnext.set.find.js";
import "core-js/modules/esnext.set.intersection.js";
import "core-js/modules/esnext.set.is-disjoint-from.js";
import "core-js/modules/esnext.set.is-subset-of.js";
import "core-js/modules/esnext.set.is-superset-of.js";
import "core-js/modules/esnext.set.join.js";
import "core-js/modules/esnext.set.map.js";
import "core-js/modules/esnext.set.reduce.js";
import "core-js/modules/esnext.set.some.js";
import "core-js/modules/esnext.set.symmetric-difference.js";
import "core-js/modules/esnext.set.union.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Component, Inject, InjectReactive, Prop, VModel, Vue } from 'nuxt-property-decorator';
import { debounce } from 'throttle-debounce';
var EvaluationWatsonDetails = (_dec = InjectReactive('evaluation'), _dec2 = Inject('postEvaluation'), _dec3 = VModel(), _dec4 = Prop(), _dec5 = Prop(), _dec6 = Prop(), Component(_class = (_class2 = /*#__PURE__*/function (_Vue) {
  function EvaluationWatsonDetails() {
    var _this;
    _classCallCheck(this, EvaluationWatsonDetails);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, EvaluationWatsonDetails, [].concat(args));
    _initializerDefineProperty(_this, "evaluation", _descriptor, _this);
    _initializerDefineProperty(_this, "postEvaluation", _descriptor2, _this);
    _initializerDefineProperty(_this, "show", _descriptor3, _this);
    _initializerDefineProperty(_this, "watsonType", _descriptor4, _this);
    _initializerDefineProperty(_this, "bookReferences", _descriptor5, _this);
    _initializerDefineProperty(_this, "caseReferences", _descriptor6, _this);
    return _this;
  }
  _inherits(EvaluationWatsonDetails, _Vue);
  return _createClass(EvaluationWatsonDetails, [{
    key: "watsonName",
    get: function get() {
      if (this.watsonType === 'book') {
        return 'WatsonB（書籍）';
      } else if (this.watsonType === 'case') {
        return 'WatsonC（判例）';
      } else {
        return 'Watson';
      }
    }
  }, {
    key: "documentTypeName",
    get: function get() {
      if (this.watsonType === 'book') {
        return '書籍';
      } else if (this.watsonType === 'case') {
        return '判例';
      } else {
        return '書籍';
      }
    }
  }, {
    key: "Reasons",
    get: function get() {
      if (this.watsonType === 'book') {
        return ['一般的・抽象的すぎるため今は関係ない文献が含まれている', '限定的・具体的すぎるため今は関係ない文献が含まれている', '過去の内容であり現在は正しくない文献が含まれている', '難解・学術的すぎて参考にできない文献が含まれている', '表示上の問題があり参考にできない文献が含まれている', '探したいものに対して全く関係ない文献が含まれている'];
      } else if (this.watsonType === 'case') {
        // TODO 判例に対して以下の表現が適切か？
        return ['限定的・具体的すぎるため今は関係ない判例が含まれている', '過去の内容であり現在の法令や解釈には馴染まない判例が含まれている', '表示上の問題があり参考にできない判例が含まれている', '探したいものに対して全く関係ない判例が含まれている'];
      } else {
        return [];
      }
    }
  }, {
    key: "model",
    get: function get() {
      if (this.watsonType === 'book') {
        return this.evaluation.watsonB;
      } else if (this.watsonType === 'case') {
        return this.evaluation.watsonC;
      } else {
        return {};
      }
    }
  }, {
    key: "impressionReasons",
    get: function get() {
      var _this$model$impressio, _this$model$impressio2;
      return (_this$model$impressio = (_this$model$impressio2 = this.model.impressions) === null || _this$model$impressio2 === void 0 ? void 0 : _this$model$impressio2.map(function (x) {
        return x.reason;
      })) !== null && _this$model$impressio !== void 0 ? _this$model$impressio : [];
    },
    set: function set(value) {
      var _this$model$impressio3;
      var reasons = new Set(value);
      var existing = ((_this$model$impressio3 = this.model.impressions) !== null && _this$model$impressio3 !== void 0 ? _this$model$impressio3 : []).flatMap(function (imp) {
        if (reasons.has(imp.reason)) {
          reasons.delete(imp.reason);
          return [imp];
        } else {
          return [];
        }
      });
      Vue.set(this.model, 'impressions', [].concat(_toConsumableArray(existing), _toConsumableArray(Array.from(reasons, function (reason) {
        return {
          reason: reason
        };
      }))));
      this.postEvaluation();
    }
  }, {
    key: "impressionDocuments",
    get: function get() {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      var self = this;
      if (this.watsonType === 'book') {
        var _ref;
        return ((_ref = this.model.impressions) !== null && _ref !== void 0 ? _ref : []).reduce(function (acc, imp) {
          return Object.defineProperty(acc, imp.reason, {
            get: function get() {
              var _imp$naturalIDs;
              return (_imp$naturalIDs = imp.naturalIDs) !== null && _imp$naturalIDs !== void 0 ? _imp$naturalIDs : [];
            },
            set: function set(value) {
              Vue.set(imp, 'naturalIDs', value);
              self.postEvaluation();
            }
          });
        }, {});
      }
      if (this.watsonType === 'case') {
        var _ref2;
        return ((_ref2 = this.model.impressions) !== null && _ref2 !== void 0 ? _ref2 : []).reduce(function (acc, imp) {
          return Object.defineProperty(acc, imp.reason, {
            get: function get() {
              var _imp$caseIDs;
              return (_imp$caseIDs = imp.caseIDs) !== null && _imp$caseIDs !== void 0 ? _imp$caseIDs : [];
            },
            set: function set(value) {
              Vue.set(imp, 'caseIDs', value);
              self.postEvaluation();
            }
          });
        }, {});
      }
      return {};
    }
  }, {
    key: "references",
    get: function get() {
      if (this.watsonType === 'book') {
        return this.bookReferences;
      } else if (this.watsonType === 'case') {
        return this.caseReferences;
      } else {
        return [];
      }
    }
  }, {
    key: "referenceItemName",
    value: function referenceItemName(ref) {
      if (ref.record.type === 'case') {
        return "".concat(ref.record.displayName, " / ").concat(ref.record.source);
      } else {
        var r = ref.record;
        return "".concat(r.title, " / ").concat(r.authors.join('、'), " / ").concat(r.publisher);
      }
    }
  }, {
    key: "onInputMissing",
    value: function onInputMissing(value) {
      Vue.set(this.model, 'missing', value.trim());
      this.postEvaluation();
    }
  }, {
    key: "onInputComment",
    value: function onInputComment(value) {
      Vue.set(this.model, 'comment', value.trim());
      this.postEvaluation();
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.onInputMissing = debounce(1000, this.onInputMissing);
      this.onInputComment = debounce(1000, this.onInputComment);
    }
  }]);
}(Vue), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "evaluation", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "postEvaluation", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "show", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "watsonType", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "bookReferences", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "caseReferences", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2)) || _class);
export { EvaluationWatsonDetails as default };